var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"bar",style:({ background: _vm.barColor, width: _vm.width + '%' })}),_c('div',{staticClass:"strength",style:({ color: _vm.barColor, width: _vm.width + '%' })},[_vm._v(" "+_vm._s(_vm.strength)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }